import React from 'react';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  HttpLink,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const cache = new InMemoryCache();

/**
 * Prod: https://9uowh1nii7.execute-api.ap-southeast-1.amazonaws.com/prod/graphql
 * Develop: https://dut2w0u7w4.execute-api.ap-southeast-1.amazonaws.com/dev/graphql
 * Release: https://zrgbuioftj.execute-api.ap-southeast-1.amazonaws.com/release/graphql
 * Localhost: http://localhost:4000
 */
const httpLink = new HttpLink({
  uri: 'https://9uowh1nii7.execute-api.ap-southeast-1.amazonaws.com/prod/graphql',
});

const authLink = setContext(async (_, { headers }) => {
  const query = Auth.currentSession();

  return new Promise((resolve) => {
    query.then(({ accessToken: { jwtToken } }) => {
      resolve({
        headers: {
          ...headers,
          authorization: jwtToken ? `Bearer ${jwtToken}` : '',
        },
      });
    });
  });
});

const apolloClient = new ApolloClient({
  cache,
  link: authLink.concat(httpLink),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

/**
 * Starts up ApolloClient only when user is logged in.
 */
const Connect = ({ isLoggedIn, children }) =>
  isLoggedIn ? (
    <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
  ) : (
    <></>
  );

Connect.propTypes = {
  children: PropTypes.node.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default Connect;
